module.exports = __webpack_public_path__ + "img/caj.dd3a2860.png";